import { AxiosRequestConfig } from 'axios';

import Interceptor from '@/classes/Interceptor';

import baseInterceptor from './base';

const interceptor = (request: AxiosRequestConfig): AxiosRequestConfig => {
  return {
    ...baseInterceptor.request && baseInterceptor.request(request),
    baseURL: process.env.VUE_APP_USERPREFERENCES_API,
  };
};

export default new Interceptor({ request: interceptor });
